"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DragAndDropList = void 0;
var core_1 = require("@blueprintjs/core");
var lodash_1 = require("lodash");
var mobx_react_1 = require("mobx-react");
var react_1 = __importStar(require("react"));
var react_beautiful_dnd_1 = require("react-beautiful-dnd");
var Card_1 = require("../Card");
var EmptyData_1 = require("../SelectionList/EmptyData");
var Spinner_1 = require("../Spinner");
var DNDItemWrapper_1 = require("./DNDItemWrapper");
var DNDList_1 = require("./DNDList");
var style_1 = require("./style");
var reorder = function (list, startIndex, endIndex) {
    var result = list;
    var removed = result.list.splice(startIndex, 1)[0];
    result.list.splice(endIndex, 0, removed);
    return result;
};
var DragDropContext = react_beautiful_dnd_1.DragDropContext;
var Draggable = react_beautiful_dnd_1.Draggable;
var Droppable = react_beautiful_dnd_1.Droppable;
var move = function (source, destination, droppableSource, droppableDestination, draggableId) {
    var itemToMove = source.list.find(function (item) { return item.value === draggableId; });
    var sourceClone = source;
    var destClone = destination;
    if (itemToMove) {
        sourceClone.list = sourceClone.list.filter(function (item) { return item.value !== itemToMove.value; });
        destClone.list.splice(droppableDestination.index, 0, itemToMove);
    }
    return [sourceClone, destClone];
};
exports.DragAndDropList = (0, mobx_react_1.observer)(function (props) {
    var _a = (0, react_1.useState)({
        items: props.list,
        filterValues: {},
        draggableId: '',
        selectedItemId: '',
        draggableItemSourceId: ''
    }), state = _a[0], setState = _a[1];
    (0, react_1.useEffect)(function () {
        setState(__assign(__assign({}, state), { items: props.list || [], selectedItemId: '' }));
    }, [props.list]);
    (0, react_1.useEffect)(function () {
        var newFilters = {};
        props.list.forEach(function (item) {
            if (item.allowFilter) {
                newFilters["filter_".concat(item.id)] = '';
            }
        });
        setState(__assign(__assign({}, state), { items: props.list || [] }));
    }, []);
    var updateFilter = function (value, key) {
        var filterValues = state.filterValues;
        filterValues[key] = value;
        setState(__assign(__assign({}, state), { filterValues: filterValues }));
    };
    var getList = function (id) {
        return ((0, lodash_1.find)(props.list, function (value) {
            return value.id === id;
        }) || { id: '', list: [] });
    };
    var displayItem = function (item, criteria, allowFilter) {
        if (!allowFilter || !criteria || !item.label) {
            return true;
        }
        return item.label
            .toString()
            .toLowerCase()
            .includes(criteria.toString().toLowerCase());
    };
    var onDragStart = function (initial, provided) {
        setState(__assign(__assign({}, state), { draggableId: initial.draggableId, draggableItemSourceId: initial && initial.source && initial.source.droppableId }));
    };
    var onDragEnd = function (result) {
        var source = result.source, destination = result.destination;
        if (!destination) {
            setState(__assign(__assign({}, state), { draggableId: '', draggableItemSourceId: '' }));
            return;
        }
        var items = {};
        if (source.droppableId === destination.droppableId) {
            items = reorder(getList(source.droppableId), source.index, destination.index);
            setState(__assign(__assign({}, state), items));
        }
        else {
            items = move(getList(source.droppableId), getList(destination.droppableId), source, destination, state.draggableId);
        }
        if (props.onDragAndDrop) {
            props.onDragAndDrop({
                source: source,
                destination: destination,
                list: state.items,
                draggableId: state.draggableId
            });
        }
        setState(__assign(__assign(__assign({}, state), items), { draggableId: '', draggableItemSourceId: '' }));
    };
    var handleItemSelection = function (itemId, listId) {
        if (props.allowItemSelection) {
            var selectedItemId = itemId !== state.selectedItemId ? itemId : '';
            setState(__assign(__assign({}, state), { selectedItemId: selectedItemId }));
            if (props.onItemSelected) {
                props.onItemSelected(selectedItemId, listId);
            }
        }
    };
    var handleDoubleClick = function (selectedItemId, listId) {
        if (props.allowItemSelection) {
            setState(__assign(__assign({}, state), { selectedItemId: selectedItemId }));
            if (props.onDoubleClickItem) {
                props.onDoubleClickItem(selectedItemId, listId);
            }
        }
    };
    var handleHelpButtonCLicked = function (itemId, source, destination) {
        var lists = state.items;
        var sourceList = lists.find(function (e) { return e.id === source; });
        if (sourceList) {
            var item = sourceList.list.find(function (i) { return i.value === itemId; });
            if (item) {
                sourceList.list = sourceList.list.filter(function (i) { return i.value !== itemId; });
                var destList_1 = lists.find(function (e) { return e.id === destination; });
                if (destList_1) {
                    destList_1.list = __spreadArray(__spreadArray([], destList_1.list, true), [item], false);
                }
                if (destList_1) {
                    lists.some(function (item, index) {
                        var result = item.id === sourceList.id;
                        if (result) {
                            lists[index] = sourceList;
                        }
                        return result;
                    });
                    lists.some(function (item, index) {
                        var result = item.id === destList_1.id;
                        if (result) {
                            lists[index] = destList_1;
                        }
                        return result;
                    });
                    setState(__assign(__assign({}, state), { items: lists, selectedItemId: itemId }));
                    if (props.onHelpButtonClicked) {
                        props.onHelpButtonClicked(itemId, source, destination);
                    }
                }
            }
        }
    };
    return (react_1.default.createElement(style_1.DNDContainer, { orientation: props.containerOrientation },
        react_1.default.createElement(DragDropContext, { onDragEnd: onDragEnd, onDragStart: onDragStart }, props.list.map(function (value, index) {
            return (react_1.default.createElement(Droppable, { droppableId: value.id, key: index }, function (provided, snapshot) { return (react_1.default.createElement(Card_1.VCardPanel, { bodyPadding: '5px', width: value.width || '200px', headerText: value.label, height: value.height || '250px', id: value.id, headerColor: value.headerColor, headerBackgroundColor: value.headerBackgroundColor }, (value.loading && (react_1.default.createElement(style_1.DragListSpinnerContainer, null,
                react_1.default.createElement(Spinner_1.VSpinner, { size: 100 })))) || (react_1.default.createElement(style_1.StyledDivContainer, { sourceListBackGroundColor: props.sourceListBackGroundColor, className: (state.draggableId &&
                    state.draggableItemSourceId === value.id &&
                    'sourceList') ||
                    '' },
                (value.allowFilter && (react_1.default.createElement(style_1.FilterInput, { fill: true, id: "filter_".concat(value.id), round: true, noLabel: true, leftIcon: 'search', value: state.filterValues["filter_".concat(value.id)], onChange: function (filterValue) {
                        updateFilter(filterValue, "filter_".concat(value.id));
                    }, rightElement: react_1.default.createElement(core_1.Button, { icon: 'refresh', onClick: function () {
                            updateFilter('', "filter_".concat(value.id));
                        }, minimal: true, small: true }) }))) ||
                    null,
                react_1.default.createElement("div", { style: { height: '100%' } },
                    react_1.default.createElement(DNDList_1.DNDList, { innerRef: provided.innerRef, provided: provided, value: value },
                        (value === null || value === void 0 ? void 0 : value.list.length) > 0 ? (value.list
                            .filter(function (item) {
                            return displayItem(item, state.filterValues["filter_".concat(value.id)], !!value.allowFilter);
                        })
                            .map(function (item, index) { return (react_1.default.createElement(Draggable, { key: "".concat(value.id, "-").concat(item.value), draggableId: item.value, index: index }, function (providedDraggable, snapshotDraggable) { return (react_1.default.createElement(DNDItemWrapper_1.DNDItemWrapper, { innerRef: providedDraggable.innerRef, disabled: value === null || value === void 0 ? void 0 : value.disabled, onClick: function () {
                                handleItemSelection(item.value, value.id);
                            }, onDoubleClick: function () {
                                handleDoubleClick(item.value, value.id);
                            }, className: "".concat(state.selectedItemId &&
                                state.selectedItemId === item.value &&
                                'dndItemSelected'), providedDraggable: providedDraggable, item: item, displayButtons: props.showHelpButtons &&
                                item.value === state.selectedItemId, selectedItemHelpButtons: props.selectedItemHelpButtons, value: value })); })); })) : (react_1.default.createElement(EmptyData_1.EmptyData, { settings: {} })),
                        provided.placeholder)))))); }));
        }))));
});
